export const getRecaptchaScript = () => `<script id="recaptcha-script">
const recaptchaContainer = document.querySelector('.template-editor__recaptcha-wrapper');
if (recaptchaContainer && window.self === window.top) {
    window['recaptchaCallback']  = () => {
        document.querySelector('form input[type="submit"]')?.removeAttribute("disabled");
    };
    window['recaptchaExpiredCallback'] = () => {
        document.querySelector('form input[type="submit"]')?.setAttribute("disabled", "");
    };
    recaptchaContainer.innerHTML = '<div class="g-recaptcha" data-sitekey="6LcrnnAeAAAAAKCHYWuH2_5kSi9xvFn298xVJsZQ" data-callback="recaptchaCallback" data-expired-callback="recaptchaExpiredCallback"></div>';
    document.querySelector('input[type="submit"]')?.setAttribute("disabled", "");

    const s = document.createElement("script");
    s.defer = true;
    s.async = true;
    s.src = "https://www.google.com/recaptcha/api.js";
    document.body.appendChild(s);
};
</script>`;
